<div class="page-area">
    <div class="dashboard-box">
        <div class="selectboxes">
            <div class="selectbox">
                <div class="department">
                    <h5>Department</h5>
                    <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a person" [(ngModel)]="selectedValue">
                        <nz-option nzLabel="Jack" nzValue="jack"></nz-option>
                        <nz-option nzLabel="Lucy" nzValue="lucy"></nz-option>
                        <nz-option nzLabel="Tom" nzValue="tom"></nz-option>
                    </nz-select>
                </div>
                <div class="designation-refresh">
                    <div class="designation">
                        <h5><label nz-checkbox [(ngModel)]="checked">Designation wise</label></h5>
                    </div>
                    <div class="refresh">
                        <h5>Auto Refresh Minutes</h5>
                        <input numbersOnly nz-input [(ngModel)]="demoValue" class="refresh-input">
                    </div>
                    <div id="date">
                        <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                    </div>
                    <div id="button">
                        <button type="button" id="refresh-btn">Refresh</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-8 col-sm-12 col-xs-12">
            <div class="dashboard-box">
                <div class="chart-wrapper">
                    <canvas baseChart 
                        [datasets]="lineChartData" 
                        [labels]="lineChartLabels" 
                        [options]="lineChartOptions"
                        [colors]="lineChartColors" 
                        [legend]="lineChartLegend" 
                        [chartType]="'bar'" 
                        [plugins]="lineChartPlugins">
                    </canvas>
                </div>
            </div>
        </div>

        <div class="col-lg-4 col-sm-12 col-xs-12">
            <div class="dashboard-box" style="height: calc(100% - 30px);">
                <div class="attendance-summary">
                    <div class="tabletop-description">
                        <div class="summary-decs">
                            <h5>Attendance summary</h5>
                        </div>
                        <div class="dashboard-box">
                            <div class="chart-wrapper">
                                <canvas baseChart 
                                    [datasets]="pieChartData" 
                                    [labels]="pieChartLabels" 
                                    [options]="lineChartOptions"
                                    [legend]="lineChartLegend" 
                                    [chartType]="'pie'" 
                                    [plugins]="lineChartPlugins">
                                </canvas>
                            </div>
                        </div>
                        <div class="attendance-details">
                            <div class="employeebox">
                                <div class="employ-title">
                                    <h5>Total Employees:</h5>
                                </div>
                                <div class="employe-cont">
                                    <h5>51</h5>
                                </div>
                            </div>
                            <div class="employeebox">
                                <div class="employ-title">
                                    <h5>Present:</h5>
                                </div>
                                <div class="employe-cont">
                                    <h5>15</h5>
                                </div>
                            </div>
                            <div class="employeebox">
                                <div class="employ-title">
                                    <h5>Absent:</h5>
                                </div>
                                <div class="employe-cont">
                                    <h5>36</h5>
                                </div>
                            </div>
                            <div class="employeebox">
                                <div class="employ-title">
                                    <h5>Shift not Started:</h5>
                                </div>
                                <div class="employe-cont">
                                    <h5>0</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-4 col-sm-12 col-xs-12">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Late in Details</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData" [nzSize]="'small'" [nzScroll]="{ x: '1100px', y: '300px' }">
                    <thead>
                        <tr>
                            <th>Emp-code</th>
                            <th>Employee Name</th>
                            <th>Shift Name</th>
                            <th>Department</th>
                            <th>Total emp.</th>
                            <th>Present</th>
                            <th>Absent</th>
                            <th>Pending shift</th>
                            <th>Designation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data" (dblclick)="open()">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>
                                <a>action</a>
                            </td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
        <div class="col-lg-4 col-sm-12 col-xs-12">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description ">
                        <h5>Department wise attendance</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData" [nzSize]="'small'" [nzScroll]="{ x: '1100px', y: '300px' }">
                    <thead>
                        <tr>
                            <th>Emp-code</th>
                            <th>Employee Name</th>
                            <th>Shift Name</th>
                            <th>Department</th>
                            <th>Total emp.</th>
                            <th>Present</th>
                            <th>Absent</th>
                            <th>Pending shift</th>
                            <th>Designation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data" (dblclick)="open()">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
        <div class="col-lg-4 col-sm-12 col-xs-12">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description ">
                        <h5>Designation wise attendance</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData" [nzSize]="'small'" [nzScroll]="{ x: '1100px', y: '300px' }">
                    <thead>
                        <tr>
                            <th>Emp-code</th>
                            <th>Employee Name</th>
                            <th>Shift Name</th>
                            <th>Department</th>
                            <th>Total emp.</th>
                            <th>Present</th>
                            <th>Absent</th>
                            <th>Pending shift</th>
                            <th>Designation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data" (dblclick)="open()">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
    

    <div class="dashboard-box dashboard-box2">
        <div class="table-attendbox">
            <div class="table-box">
                
                
            </div>
            <div class="table-box attend-tablebox">
                
                <!-- attendance summary -->
                
            </div>


        </div>
    </div>
</div>

<nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '0px' }"
    [nzMaskClosable]="false" [nzWidth]="430" [nzVisible]="visible"
    [nzTitle]=" (isEdit ? 'Update' : 'Create') + ' Company Type'" (nzOnClose)="close()">
    <div class="drawer-content">
        
    </div>
</nz-drawer>